// @ts-check
/**
 * Export typed properties of window object
 */
// MAP_GROUP
export const mapGroupStates = {};
/**
 * @type {(mapGroups: ReturnType<typeof getGlobal>['Gdata']['CurrentMap']['ori'][0]['mapGroups']) => void}
 */
export const setAllMapGroupSetStates = (mapGroups = []) => {
  const {
    CurrentMap: { ori },
  } = window.Gdata;
  ori[0].mapGroups = mapGroups;

  Object.keys(mapGroupStates).forEach(key => {
    mapGroupStates[key](mapGroups);
  });
};
